import api from './api';

const UserService = {
    list: () => api.get('/users').then(r => r.data),
    /** Names of the active team (everyone may read it), for assignment dropdowns and filters. */
    directory: () => api.get('/users/directory').then(r => r.data),
    invite: (payload) => api.post('/users/invite', payload).then(r => r.data),
    resendInvite: (id) => api.post(`/users/${id}/invite`).then(r => r.data),
    update: (id, payload) => api.put(`/users/${id}`, payload).then(r => r.data),
    remove: (id) => api.delete(`/users/${id}`),
    // Public: the invitee's account setup page.
    inviteInfo: (token) => api.get('/auth/invite', { params: { token } }).then(r => r.data),
    acceptInvite: (payload) => api.post('/auth/invite/accept', payload).then(r => r.data),
};

export default UserService;
